export enum BillBalanceModifierReference {
  BankPayment = 'bankPayment',
  Bill = 'bill',
  ContactBalancePayment = 'contactBalancePayment',
  DaybookTransaction = 'daybookTransaction',
}
